import axios from "@/http/request";

// 获取其他配置信息
export function getElseConfigured(data) {
    return axios({
        url: "sys/sensitiveWords/loadById",
        method: "post",
        data
    });
}

// 查询指定用户信息
export function queryUserinfo(data) {
    return axios({
        url: "sys/user/findByUserUserId",
        method: "post",
        data
    });
}

// 保存聊天消息
export function saveImMsg(data) {
    return axios({
        url: "sys/user/sendImMsg",
        method: "post",
        data
    });
}

// 获取订单信息
export function getOrderInfo(data) {
    return axios({
        url: "sys/accountOrder/loadById",
        method: "post",
        data
    });
}

// Issue a UserSig from the server (replaces local HMAC signing)
export function imUserSig() {
    return axios({
        url: "sys/im/userSig",
        method: "post"
    })
}
